const STATUS = Object.freeze({
  PENDING: "PEN",
  PAID: "PAI",
});

export default Object.freeze({
  STATUS: STATUS,
});
